import 'ol/ol.css';
import './styles.css';
import { App } from './App';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('No se encontró el contenedor de la aplicación.');
new App(root);
